// src/modules/redux/reducers/authActions.js
export const login = () => ({
    type: 'LOGIN',
    // payload: user,
  });
  
  export const logout = () => ({
    type: 'LOGOUT',
  });
  